import { render, staticRenderFns } from "./TourSummaryCard.vue?vue&type=template&id=bff37b5c"
import script from "./TourSummaryCard.vue?vue&type=script&lang=js"
export * from "./TourSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports